/**
 * @class FormatOption
 */
export default class FormatOption {
    /**
     * @param {String}  key
     * @param {String}  name
     * @param {Array}   defaultValues
     * @param {Array}   values
     * @param {String}  optionType
     * @param {String}  type
     * @param {Array}   value
     */
    constructor(key, name, defaultValues, values, optionType, type, value = []) {
        this._key = key;
        this._name = name;
        this._defaultValues = defaultValues;
        this._values = values;
        this._optionType = optionType;
        this._type = type;
        this._value = value;

        if (typeof this._key !== "string") {
            throw new Error("Invalid datatype of key");
        }
    }

    /**
     * @return {String}
     */
    get key() {
        return this._key;
    }

    /**
     * @param {String} key
     */
    set key(key) {
        this._key = key;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {Array}
     */
    get defaultValues() {
        return this._defaultValues;
    }

    /**
     * @param {Array} defaultValues
     */
    set defaultValues(defaultValues) {
        this._defaultValues = defaultValues;
    }

    /**
     * @return {Array}
     */
    get values() {
        return this._values;
    }

    /**
     * @param {Array} values
     */
    set values(values) {
        this._values = values;
    }

    /**
     * @return {String}
     */
    get optionType() {
        return this._optionType;
    }

    /**
     * @param {String} optionType
     */
    set optionType(optionType) {
        this._optionType = optionType;
    }

    /**
     * @return {String}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {String} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {Array}
     */
    get value() {
        return this._value;
    }

    /**
     * @param {Array} value
     */
    set value(value) {
        this._value = value;
    }

    /**
     * @return {Object}
     */
    clone() {
        return new FormatOption(
            this._key,
            this._name,
            this._defaultValues,
            this._values,
            this._optionType,
            this._type,
            this._value
        );
    }

    /**
     * Clones FormatOption object and updates selected value property.
     * @param {Array}  value
     * @return {Object}
     */
    updateValue = (value) => {
        let option = this.clone();
        option.value = value;

        return option;
    };

    /**
     * @return {String}
     */
    toString() {
        return "FormatOption (" + this._key + ")";
    }
}
